define([
    './defined',
    './defaultValue',
    '../System/Vec3Obj',
    '../System/CircleObj',
    '../System/WayPoint'
], function (
    defined,
    defaultValue,
    Vec3Obj,
    CircleObj,
    WayPoint
) {
    'use strict'

    /**
     * 将对象序列化为JSON格式的字符串，支持多种类型
     *
     * @private
     *
     * @exports object2Json
     */
    const object2Json = {};
    
    // 存储不同类型的序列化处理函数
    const typeHandlers = {};
    
    /**
     * 注册新的类型序列化处理器
     * @param {String} type - 要序列化为的类型标识
     * @param {Function} handler - 处理该类型的函数，接收对象数组和额外选项，返回对象
     */
    object2Json.registerTypeHandler = function(type, handler) {
        if (typeof handler === 'function') {
            typeHandlers[type] = handler;
        }
    };
    
    /**
     * 将对象数组序列化为JSON字符串
     * @param {String} type - 要序列化的类型
     * @param {Array} objectArray - 要序列化的对象数组
     * @param {Object} options - 额外选项，传递给类型处理器
     * @return {String} 序列化后的JSON字符串
     */
    object2Json.stringify = function(type, objectArray, options) {
        options = defaultValue(options, {});
        
        try {
            if (defined(type) && Array.isArray(objectArray)) {
                const handler = typeHandlers[type];
                
                if (handler) {
                    // 使用注册的处理器处理对象数组
                    const jsonObj = handler(objectArray, options);
                    // 添加类型标识
                    jsonObj.type = type;
                    // 序列化为字符串
                    return JSON.stringify(jsonObj);
                } else {
                    console.warn('未找到类型 "' + type + '" 的序列化处理器');
                }
            } else {
                console.warn('参数不正确，需要类型和对象数组');
            }
        } catch (e) {
            console.error('序列化对象数组失败:', e);
        }
        
        return '';
    };
    
    // 注册TUPLE3D类型序列化处理器
    object2Json.registerTypeHandler('TUPLE3D', function(vecArray, options) {
        const result = {
            array: []
        };
        
        if (Array.isArray(vecArray)) {
            for (let i = 0; i < vecArray.length; ++i) {
                const vec = vecArray[i];
                if (vec instanceof Vec3Obj || (defined(vec.x) && defined(vec.y) && defined(vec.z))) {
                    result.array.push({
                        x: vec.x,
                        y: vec.y,
                        z: vec.z
                    });
                }
            }
        }
        
        return result;
    });
    
    // 注册COMPOSITE类型序列化处理器
    object2Json.registerTypeHandler('COMPOSITE', function(array, options) {
        const result = {
            array: []
        };
        
        if (Array.isArray(array)) {
            for (let i = 0; i < array.length; ++i) {
                const obj = array[i];
                if (obj instanceof CircleObj || 
                    (defined(obj.radius) && defined(obj.color) && 
                     defined(obj.textColor) && defined(obj.text))) {
                    
                    // 检查颜色是否为ColorObj对象并转换为十六进制
                    let color = obj.color;
                    if (color && typeof color === 'object' && typeof color.toHexStr === 'function') {
                        color = color.toHexStr();
                    }
                    let textColor = obj.textColor;
                    if (textColor && typeof textColor === 'object' && typeof textColor.toHexStr === 'function') {
                        textColor = textColor.toHexStr();
                    }
                    result.array.push({
                        radius: obj.radius,
                        color: color,
                        textColor: textColor,
                        text: obj.text
                    });
                } else if(obj instanceof WayPoint ||  (defined(obj.position) && defined(obj.radius) && defined(obj.orientation))) {
                    result.array.push({
                        position: obj.position,
                        radius: obj.radius,
                        orientation: obj.orientation
                    });
                }
            }
        }
        
        return result;
    });
    
    return object2Json;
});